export default {
  pageSurface: '#121519',
  secondary50: '#202228',
  secondary100: '#272A30',
  secondary200: '#31343C',
  secondary300: '#3A3E47',
  secondary400: '#858B99',
  secondary500: '#A7ADB8',
  secondary600: '#B8BEC9',
  secondary700: '#CCD1D8',
  secondary800: '#E1E4EA',
  secondary850: '#ECEEF2',
  secondary900: '#F5F7FA',
  gray5: '#1C1F24',
  gray50: '#2A2F37',
  gray100: '#333943',
  gray600: '#A9B1BE',
  gray900: '#F1F4F8',
  mutedSurface: 'rgba(9, 11, 15, 0.76)',
  selectionSurface: '#1D3A2A',
  deleteSurface: '#4A262D',
  whiteSurface: '#1C2026',
  lightnessGreenSurface: '#1B2521',
  successSurface: '#1B2521',
  warningSurface: '#2A2517',
  infoSurface: '#17252A',
  dangerSurface: '#2A1B1D',
  // mistura de dangerSurface com pageSurface (tom critico mais recuado)
  dangerSubtleSurface: '#1E181B',
  attentionSurface: '#2A2117',
  ownerSurface: '#1F1B2A',
  maintenanceSurface: '#D97A54',
  commercialSurface: '#7D84D6',
  operationalSurface: '#4BBFAA',
  specializedSurface: '#B876C9',
  highBlack: 'rgba(255, 255, 255, 0.92)',
  mediumHighBlack: 'rgba(255, 255, 255, 0.78)',
  mediumBlack: 'rgba(255, 255, 255, 0.66)',
  lowBlack: 'rgba(255, 255, 255, 0.48)',
  highWhite: 'rgba(255, 255, 255, 0.96)',
  mediumWhite: 'rgba(255, 255, 255, 0.72)',
  lowWhite: 'rgba(255, 255, 255, 0.52)',
  hoverGrey: 'rgba(255, 255, 255, 0.06)',
  lightGrey: 'rgba(255, 255, 255, 0.2)',
  lightGreyBorder: 'rgba(255, 255, 255, 0.16)',
  blackShades: opacity => `rgba(255, 255, 255, ${opacity})`,
  tableHeader: '#252A33',
  tableHover: '#2C323D',
  tableBg: '#1E232C',
  tableCellBorder: 'rgba(255, 255, 255, 0.16)',
  breadcrumb: '#B5BCCC',
  navbarSurface: '#0A2E34',
  navbarActiveSurface: '#0E3E46',
  tabBorderColor: '#2D313A',
  guidedAttendance: {
    text: {
      talk: '#1D3A2A',
      action: '#1C3344',
      warning: '#4A262D',
    },
  },
};
